// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { castToString } from 'helpers/reduxFormFunctions'
import {
  getUnitLabelForMetersAndFeet,
  valueFromMeters,
} from 'helpers/unitConversion'

// instead of creating custom formatters for these cells,
// just put the values of interest at the top level of the object.
const prepData = (arr, unitType) => (
  arr.map(d => {
    d.asr = d.registrationNumber // FCC doesn't call it ASR but lego does.

    // FCC data is in metric - convert as necessary and cast to string
    // for redux-form to consume if selected.
    d.elevation = castToString(valueFromMeters(d.groundElevation, unitType))
    d.overallHeight = castToString(valueFromMeters(d.overallHeightAboveGround, unitType))

    // presented to the user as a tooltip on the Overall Height column
    d.structureHeight = `${valueFromMeters(d.heightOfStructure, unitType)} ${getUnitLabelForMetersAndFeet(unitType)}`

    d.entityName = castToString(d.entityName)
    d.latitude = `${d.latDegrees} ${d.latMinutes} ${d.latSeconds} ${d.latDirection}`
    d.longitude = `${d.longDegrees} ${d.longMinutes} ${d.longSeconds} ${d.longDirection}`
    d.uniqueId = 'asr' //  for DataTable to have a unique id.
    return d
  })
)

export default prepData
